module.exports = __webpack_public_path__ + "static/media/warning-icon.3f6e28ae.svg";